import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content-grid content-grid--subpage" }
const _hoisted_2 = { class: "content-grid__header" }
const _hoisted_3 = { class: "back-link-title" }

import Card from '@/components/layout/Card.vue';
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue';
import MembershipsForm from '@/components/memberships/MembershipsForm.vue';

import { useI18n } from "vue3-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'AdminMembershipsIndex',
  setup(__props) {

const { t } = useI18n()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Breadcrumbs, {
      title: _unref(t)('routes.admin.children.memberships.name')
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(t)(`routes.admin.children.memberships.name`)), 1)
    ]),
    _createVNode(Card, null, {
      default: _withCtx(() => [
        _createVNode(MembershipsForm)
      ]),
      _: 1
    })
  ]))
}
}

})